<template>
	<!--				Driver info-->
	<card-slot
			title="Driver info"
			icon="InfoCircle"
	>
		<field
				margin="0 0 10px 0"
				width="290px"
				label="Phone"
				placeholder="Enter phone"
				@updateInput="onInput($event, 'phone')"
				:setInputValue="phone"
				is-phone
				:isReadonly="getPermissionAction"
		></field>
		<field
				margin="0 0 10px 0"
				width="290px"
				label="Phone 2"
				placeholder="Enter phone 2"
				@updateInput="onInput($event, 'phone2')"
				:setInputValue="phone2"
				is-phone
				:isReadonly="getPermissionAction"
		></field>
		<field
				:classError="valid.email.$error"
				width="290px"
				margin="0 0 10px 0"
				label="Email"
				placeholder="Enter email"
				@updateInput="onInput($event, 'email')"
				:setInputValue="email"
				:isReadonly="getPermissionAction"
		></field>
		<field
				margin="0 0 10px 0"
				width="290px"
				label="Mailing address"
				placeholder="Enter mailing address"
				@updateInput="onInput($event, 'comment')"
				:setInputValue="comment"
				isTextarea
				:isReadonly="getPermissionAction"
		></field>
		<field
				margin="0 0 10px 0"
				width="290px"
				label="Information"
				placeholder="Enter information"
				@updateInput="onInput($event, 'notes')"
				:setInputValue="notes"
				isTextarea
				:isReadonly="getPermissionAction"
		></field>
	</card-slot>
</template>

<script>

import CardSlot from "@/shared/CardSlot/CardSlot.vue";

export default {
	name: "FirstTab",
	components: { CardSlot },
	props: {
		valid: Object,
		email: String,
		phone: String,
		phone2: String,
		comment: String,
		notes: String,
		getPermissionAction: Boolean
	},
	methods: {
		onInput({ value }, key) {
			this.$emit('updateFirstTab', { value, key });
		}
	}
};
</script>

<style scoped lang="scss">
@import "FirstTabDriver";
</style>
